<div class="row row-flex row-template" [nbSpinner]="loading">
  <div class="col-template-left" [ngClass]="isOpened ? '':'hidden-center'">
    <div class="template-left">
      <div class="chek-template">
        <label class="form-label">
          @if (selectedTemplate) {
            <ng-container i18n="@@VybrannyyShablon2">Выбранный шаблон
              #{{ selectedTemplate.id }}</ng-container>
          }
          @if (selectedTemplate && model.updatedAt) {
            &nbsp; &bull; &nbsp;
          }
          @if (model.updatedAt) {
            <ng-container i18n="@@PoslednieIzmeneniya">Последние изменения {{ model.updatedAt | date: 'dd.MM.yyyy HH:mm:ss' }}</ng-container>
          }
        </label>
      </div>
      <div class="template-left__name">
        <ng-select [items]="templates$ | async" bindLabel="header" bindValue="id" [minTermLength]="2" [compareWith]="compareTemplates" [loading]="loadingTemplates" [typeahead]="templateInput$" [clearable]="false" [readonly]="isMasterCard && selectedTemplate != null" (change)="changeSelectedTemplate($event)" [(ngModel)]="selectedTemplate" typeToSearchText="Пожалуйста, введите 2 или более символов" i18n-typeToSearchText="@@TemplateAutocompleteTypeToSearchText" placeholder="Введите название шаблона" i18n-placeholder="@@TemplateAutocompleteLabel"/>
      </div>

      @if (isMasterCard) {
        <ng-content select="[masterCardFeatures]"></ng-content>
      }

      <br>

      @if (bindedTemplate && bindedTemplate.groups && bindedTemplate.groups.length) {
        <nb-accordion multi class="template-left__properties">
          @for (fieldsGroup of bindedTemplate.groups; track fieldsGroup; let groupIndex = $index) {
            <nb-accordion-item #groupItem id="groupItem_{{groupIndex}}" [expanded]="true">
              <nb-accordion-item-header id="glava1" name="glava1">
                {{ fieldsGroup.header }}
                @if (isGroupFilled(fieldsGroup.id)) {
                  <span i18n="@@Iz" class="state-success">{{ allFeaturesInGroup(fieldsGroup.id) }} из {{ allFeaturesInGroup(fieldsGroup.id) }}
                    <tui-icon icon="check"/>
                  </span>
                }
                @if (isGroupNotFilled(fieldsGroup.id)) {
                  <span i18n="@@Iz2" class="state-warn">{{ emptyFeaturesInGroup(fieldsGroup.id) }} из {{ allFeaturesInGroup(fieldsGroup.id) }}
                    <tui-icon icon="triangle-alert"/></span>
                }
                <a name="glava1" [routerLink]="['/cabinet/pim/feature-group/edit/', fieldsGroup.groupId]" target="_blank" class="entityID" i18n-nbTooltip="@@OpenFeatureGroupInNewWindow" nbTooltip="Открыть группу в новом окне"> #{{ fieldsGroup.groupId }} </a>
              </nb-accordion-item-header>
              <nb-accordion-item-body>
                @for (feature of fieldsGroup.features; track feature.id) {
                  @if (isSelectableFeatureType(feature.featureTypeId)) {
                    <app-tf-select [feature]="feature" [featureLink]="true" [showRemoveButton]="isMasterCard" (removeEvent)="removeMasterCardFeatureDialog(feature.id)" class="accordion-item"/>
                  }
                  @if (isRangeFeatureType(feature.featureTypeId)) {
                    <app-tf-range [feature]="feature" [featureLink]="true" [showRemoveButton]="isMasterCard" (removeEvent)="removeMasterCardFeatureDialog(feature.id)" class="accordion-item"/>
                  }
                  @if (isBooleanFeatureType(feature.featureTypeId)) {
                    <app-tf-boolean [feature]="feature" [featureLink]="true" [showRemoveButton]="isMasterCard" (removeEvent)="removeMasterCardFeatureDialog(feature.id)" class="accordion-item"/>
                  }
                  @if (isIntervalFeatureType(feature.featureTypeId)) {
                    <app-tf-interval [feature]="feature" [featureLink]="true" [showRemoveButton]="isMasterCard" (removeEvent)="removeMasterCardFeatureDialog(feature.id)" class="accordion-item"/>
                  }
                  @if (isStringFeatureType(feature.featureTypeId)) {
                    <app-tf-string [feature]="feature" [featureLink]="true" [showRemoveButton]="isMasterCard" (removeEvent)="removeMasterCardFeatureDialog(feature.id)" class="accordion-item"/>
                  }
                  @if (isHtmlFeatureType(feature.featureTypeId)) {
                    <app-tf-html [feature]="feature" [featureLink]="true" [showRemoveButton]="isMasterCard" (removeEvent)="removeMasterCardFeatureDialog(feature.id)" class="accordion-item"/>
                  }
                  @if (isSizeFeatureType(feature.featureTypeId)) {
                    <app-tf-size [feature]="feature" [featureLink]="true" [showRemoveButton]="isMasterCard" (removeEvent)="removeMasterCardFeatureDialog(feature.id)" class="accordion-item"/>
                  }
                  @if (isLinkFeatureType(feature.featureTypeId)) {
                    <app-tf-link [feature]="feature" [featureLink]="true" [showRemoveButton]="isMasterCard" (removeEvent)="removeMasterCardFeatureDialog(feature.id)" class="accordion-item"/>
                  }
                  @if (isSmartlistFeatureType(feature.featureTypeId)) {
                    <app-tf-smartlist [feature]="feature" [featureLink]="true" [showRemoveButton]="isMasterCard" (removeEvent)="removeMasterCardFeatureDialog(feature.id)" class="accordion-item"/>
                  }
                  @if (isDateFeatureType(feature.featureTypeId)) {
                    <app-tf-date [feature]="feature" [featureLink]="true" class="accordion-item"/>
                  }
                  @if (isCompositeFeatureType(feature.featureTypeId)) {
                    <app-tf-composite [feature]="feature" [featureValues]="featureValues" [featureLink]="true" class="accordion-item"/>
                  }
                }
                @if (!fieldsGroup.features.length) {
                  <div class="empty" style="max-width: 400px" i18n="@@NetHarakteristik">Нет характеристик</div>
                }
              </nb-accordion-item-body>
            </nb-accordion-item>
          }
        </nb-accordion>
      }

      @if (isMasterCard && bindedTemplate && !bindedTemplate.groups?.length) {
        <div class="empty" style="max-width: 400px" i18n="@@MasterCardFeaturesEmptyHint">Для мастер-карты характеристики добавляются вручную — выберите их в поле «Добавить характеристики МК» выше. Пока не добавлено ни одной.</div>
      }
      <br>


      <div class="submit-button">
        <button nbButton status="primary" type="button" [disabled]="!productFeatureStatus || productFeatureStatus.error || !modelFeaturesChanges" (click)="saveFeatureModelWithMasterCardOptionsDialog()" i18n="@@Save">
          Сохранить изменения
        </button>

        <button (click)="back()" nbButton status="basic" type="button" i18n>Отмена</button>

        @if (productFeatureStatus && productFeatureStatus.empty) {
          <tui-icon icon="triangle-alert" status="warning"/>
          {{ productFeatureStatus.empty }} не заполненных полей
        }
      </div>
    </div>
  </div>
  <div class="template-features__wrap" [ngClass]="isOpened ? '':'hidden-center'">
    <button nbButton size="small" class="close-nav" type="button" (click)="toggleOpened()" i18n-nbTooltip="@@IsopenedSkrytKolonkuPokazatKolonku" nbTooltip="{{ isOpened ? 'Скрыть колонку':'Показать колонку' }}">
      <tui-icon icon="panel-left-close"/>
    </button>

    @if (isOpened) {
      <div class="template-right template-right__scroll">
        <div class="template-right__top">
          @if (selectedTemplate) {
            <h6>
              <a [routerLink]="['/cabinet/pim/template-group/item/edit', selectedTemplate.id]" target="_blank" style="text-decoration: none">
                {{ selectedTemplate.header }}
                <button nbButton size="tiny" type="button">
                  <tui-icon icon="external-link"/>
                </button>
              </a>
            </h6>
          }
          <div class="productCopyForm">
            <form [formGroup]="baseProductIdForm" (ngSubmit)="copyFeatureValues()">
              <nb-form-field>
                <input type="text" formControlName="productId" nbInput fieldSize="small" i18n-placeholder="@@VvediteIdTovaraDlyaKopirovaniya" placeholder="Введите ID товара для копирования">
                @if (!baseProductIdForm.invalid) {
                  <button nbSuffix ghost nbButton size="small" type="submit">
                    <tui-icon icon="copy"/>
                  </button>
                }
              </nb-form-field>
            </form>
          </div>
        </div>
        @if (bindedTemplate) {
          <div class="template-right__content">
            <!--          <a  class="template-right__content-item pointer" [class.item-respect]="isGroupNotFilled(group.id)"-->
            <!--               *ngFor="let group of bindedTemplate.groups; let groupIndex = index;" (click)="scrollToGroup(groupIndex)">-->
            @for (group of bindedTemplate.groups; track group; let groupIndex = $index) {
              <a (click)="scrollToGroup(groupIndex)" class="template-right__content-item pointer"> {{ group.header }}@if (isGroupNotFilled(group.id)) {
                <span class="templateGroup__stat" i18n="@@Iz3">
                  <tui-icon icon="triangle-alert" status="warning"/>
                  {{ emptyFeaturesInGroup(group.id) }} из {{ allFeaturesInGroup(group.id) }}</span>
              } </a>
            }
          </div>
        }
      </div>
    }

  </div>
</div>
